export default "__VITE_ASSET__DM2DpU8H__"